import React from 'react'
import Paragraph from '../paragraph';
import ShareSection from '../share-section';
import Stats from '../stats';
import ContactForm from '../form';
import Testimonials from '../testimonials';
import ImageContainer from '../image-section';
import TermAndCondition from '../term';
import Download from '../download';

function BodyJsonParser({ data, category,jsondata }) {
    let html;
    switch (category) {
        case 'paragraph':
            html = <Paragraph data={data} />
            break;
        case 'contactSection':
            html = <ContactForm data={data}/>
            break;
        case 'shareSection':
            html = <ShareSection data={jsondata} />
            break;
        case 'testimonial':
            html = <Testimonials
                description={data.content.remark}
                author={data.content.name}
                designation={data.content.credential} />
            break;
        case 'stats':
            html = <Stats data={data.content} />
            break;
        case 'imageSection':
            html = <ImageContainer data={data.content} image={data.content.data} imgSize={data.scategory}/>
            break;
        case 'T&C':
            html = <TermAndCondition data={data.content}/>
            break;
        case 'download':
            html = <Download />
            break;
        default:
            html = (
                <div class="alert alert-danger" role="alert">
                <strong>{category}</strong> component not defined!
                </div>
            )
            break;
    }
    return html;
}

export default BodyJsonParser

